
import proj4 from "proj4";


function convertLatLngtoPoint(lat, lng) {
  var firstProjection = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=204.64, 834.74, 293.8, 0, 0, 0, 0 +units=m +no_defs ';
  var point = proj4(firstProjection, [lng, lat]);
  point[0] = point[0];
  point[1] = point[1]   ;

  return point;
}


// var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +units=m +no_defs ';

//ท่ากระดาน var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=208,813.891,288.351,0,0,0,0 +units=m +no_defs ';

function convertCoordinatetoLatLng(geom) {
 
  let LatLng = [];
  var point = [];
  var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=204.64, 834.74, 293.8, 0, 0, 0, 0 +units=m +no_defs ';
  var dest = new proj4('EPSG:4326');

  for (let i = 0; i < geom.coordinates[0].length; i++) {
    point = proj4(source, dest, [geom.coordinates[0][i][0] , geom.coordinates[0][i][1] ])
    LatLng.push([ parseFloat(parseFloat(point[1]).toFixed(8)), parseFloat(parseFloat(point[0]).toFixed(8)) ]);
  }
  return (LatLng)
}

function convertCoordinatetoLatLngMirror(geom) {
 
  let LatLng = [];
  var point = [];
  // var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=208,813.87,288.35,0,0,0,0 +units=m +no_defs ';
  // var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=208.271,813.51,288.355,0,0,0,0 +units=m +no_defs  ';
  var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=204.64, 834.74, 293.8, 0, 0, 0, 0 +units=m +no_defs '
  // เก่า var  source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +units=m +no_defs';
  var dest = new proj4('EPSG:4326');
  for (let i = 0; i < geom.coordinates[0][0].length; i++) {
    point = proj4(source, dest, [geom.coordinates[0][0][i][0] , geom.coordinates[0][0][i][1] ])
    LatLng.push([ parseFloat(parseFloat(point[0]).toFixed(8)), parseFloat(parseFloat(point[1]).toFixed(8)) ]);
    
  }
  return (LatLng)
}

//1.ลด บนขวา , + ล่างซ้าย
// 2.+ ล่าง , - บนซ้าย
//3 + ซ้ายบน , - ขวาล่าง

function convertCoordinatetoLatLngLandCenter (geom) {
  
  let LatLng = [];
  var point = [];
  var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=204.64, 834.74, 293.8, 0, 0, 0, 0 +units=m +no_defs ';
  var dest = new proj4('EPSG:4326');
  var geom2 = [geom];
  for (let i = 0; i < geom2.length; i++) {
    point = proj4(source, dest, [geom2[i][0], geom2[i][1] ])
    // point = proj4(source, dest, [geom2[i][0] + 1.8, geom2[i][1] - 0.6])
    LatLng.push([ parseFloat(parseFloat(point[1]).toFixed(8)), parseFloat(parseFloat(point[0]).toFixed(8)) ]);
    
  }
 
  return (LatLng)
}

function convertCoordinatetoLatLngLand(geom) {

  let LatLng = [];
  var point = [];
  var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=204.64, 834.74, 293.8, 0, 0, 0, 0 +units=m +no_defs ';
  var dest = new proj4('EPSG:4326');
  var geom2 = geom[0];
  for (let i = 0; i < geom2[0].length; i++) {
    point = proj4(source, dest, [geom2[0][i][0], geom2[0][i][1] ])
    LatLng.push([ parseFloat(parseFloat(point[1]).toFixed(8)), parseFloat(parseFloat(point[0]).toFixed(8)) ]);
  }
 
  return (LatLng)
}

function convertCoordinatetoLatLngBuild(geom) {
 
  let LatLng = [];
  var point = [];
  var source = '+proj=utm +zone=47 +a=6377276.345 +b=6356075.413140239 +towgs84=204.64, 834.74, 293.8, 0, 0, 0, 0 +units=m +no_defs  ';
  var dest = new proj4('EPSG:4326');
  var geom1 = [geom.coordinates];
  var geom2 = [geom1];
  
  for (let i = 0; i < geom2.length; i++) {
    point = proj4(source, dest, [geom2[0][i][0] , geom2[0][i][1] ])
    LatLng.push([ parseFloat(parseFloat(point[1]).toFixed(8)), parseFloat(parseFloat(point[0]).toFixed(8)) ]);
  }
  return (LatLng)
}



function mapRemoveLayer(map, IDofLayers) {
  map.eachLayer(function (layer) {
    let idx = IDofLayers.indexOf(layer._leaflet_id)
    if (idx >= 0) {

      //if (layer._leaflet_id === IDofLayers) {


      map.removeLayer(layer);
    }
    if (typeof layer.options.id !== 'undefined') {
      if (layer.options.id === 'buildingtarget') {
        var wmsLayerKey = Object.keys(layer)[1];
        var randomValue = Math.floor(Math.random() * 100000001);
        layer.setParams({ random: randomValue });
      }
    }


  });




  //let ctrl = L.Layer..get.getLayer(result.leaflet_id);
  //map.removeControl(ctrl);
}

function refreshLayer(map,id){
  
  map.eachLayer(function (layer) {
    
    if (typeof layer.options.id !== 'undefined') {
      if (layer.options.id === id) {
        var wmsLayerKey = Object.keys(layer)[1];
        var randomValue = Math.floor(Math.random() * 100000001);
        layer.setParams({ random: randomValue });
      }
    }


  });
}

function convertCodePt4(fname, lname) {
  // echo $fname.' '.$lname;
  let alphabets = ['ก', 'ข', 'ฃ', 'ค', 'ฅ', 'ฆ', 'ง', 'จ', 'ฉ', 'ช', 'ซ', 'ฌ', 'ญ', 'ฎ', 'ฏ', 'ฐ', 'ฑ', 'ฒ', 'ณ', 'ด', 'ต', 'ถ', 'ท', 'ธ', 'น', 'บ', 'ป', 'ผ', 'ฝ', 'พ', 'ฟ', 'ภ', 'ม', 'ย', 'ร', 'ล', 'ว', 'ศ', 'ษ', 'ส', 'ห', 'ฬ', 'อ', 'ฮ'];

  let alphabetCode = {};
  let alphabetStr = [{ "alphabet": "ก", "code": 1 }, { "alphabet": "ข", "code": 1 }, { "alphabet": "ฃ", "code": 1 }, { "alphabet": "ค", "code": 1 }, { "alphabet": "ฅ", "code": 1 }, { "alphabet": "ฆ", "code": 1 }, { "alphabet": "ง", "code": 1 }, { "alphabet": "จ", "code": 2 }, { "alphabet": "ฉ", "code": 2 }, { "alphabet": "ช", "code": 2 }, { "alphabet": "ซ", "code": 2 }, { "alphabet": "ฌ", "code": 2 }, { "alphabet": "ญ", "code": 3 }, { "alphabet": "ฎ", "code": 3 }, { "alphabet": "ฏ", "code": 3 }, { "alphabet": "ฐ", "code": 3 }, { "alphabet": "ฑ", "code": 3 }, { "alphabet": "ฒ", "code": 4 }, { "alphabet": "ณ", "code": 4 }, { "alphabet": "ด", "code": 4 }, { "alphabet": "ต", "code": 4 }, { "alphabet": "ถ", "code": 4 }, { "alphabet": "ท", "code": 5 }, { "alphabet": "ธ", "code": 5 }, { "alphabet": "น", "code": 5 }, { "alphabet": "บ", "code": 5 }, { "alphabet": "ป", "code": 5 }, { "alphabet": "ผ", "code": 6 }, { "alphabet": "ฝ", "code": 6 }, { "alphabet": "พ", "code": 6 }, { "alphabet": "ฟ", "code": 6 }, { "alphabet": "ภ", "code": 6 }, { "alphabet": "ม", "code": 7 }, { "alphabet": "ย", "code": 7 }, { "alphabet": "ร", "code": 7 }, { "alphabet": "ล", "code": 7 }, { "alphabet": "ว", "code": 7 }, { "alphabet": "ศ", "code": 8 }, { "alphabet": "ษ", "code": 8 }, { "alphabet": "ส", "code": 8 }, { "alphabet": "ห", "code": 8 }, { "alphabet": "ฬ", "code": 9 }, { "alphabet": "อ", "code": 9 }, { "alphabet": "ฮ", "code": 9 }];
  let fnameClear = [];
  let lnameClear = [];
  for (var i = 0; i < fname.length; i++) {
    if ((alphabets.indexOf(fname.charAt(i))) >= 0)
      fnameClear.push(fname.charAt(i));
  }
  let fcodept4 = fnameClear[0];
  let looplength = 3;// (fnameClear.length >= 4? 3 : fnameClear.length-1);
  for (var i = 1; i <= looplength; i++) {
    if (i < fnameClear.length) {
      let index = alphabetStr.findIndex(x => x.alphabet === fnameClear[i]);
      fcodept4 += alphabetStr[index].code;
    }
    else
      fcodept4 += '0';
  }

  for (var i = 0; i < lname.length; i++) {
    if ((alphabets.indexOf(lname.charAt(i))) >= 0)
      lnameClear.push(lname.charAt(i));
  }
  let lcodept4 = '';
  looplength = 4;// (fnameClear.length >= 4? 3 : fnameClear.length-1);
  for (var i = 0; i < looplength; i++) {
    if (i < lnameClear.length) {
      let index = alphabetStr.findIndex(x => x.alphabet === lnameClear[i]);
      lcodept4 += alphabetStr[index].code;
    }
    else
      lcodept4 += '0';
  }

  let codept4 = fcodept4 + '/'+lcodept4;



  //alphabetCode = json_decode($alphabetStr, true);

  //$fnameSplit = $this->getMBStrSplit($fname);
  //$lnameSplit = $this->getMBStrSplit($lname);



  //first name to codept4

  //  foreach(fname as letter){
  //      foreach($alphabets as $alphabet){
  //          if($letter==$alphabet) array_push($fnameClear,$letter);
  //      }
  //  }
  //  $fsizeof = sizeof($fnameClear);
  //  // echo $fsizeof."<br/>";
  //  for($i=0;$i<sizeof($fnameClear);$i++){
  //      foreach($alphabetCode as $key=>$value){
  //          $value["alphabet"];
  //          if($fnameClear[$i]==$value["alphabet"]){
  //              if($i==0)  $fcodept4 = $fnameClear[0];
  //              else if($i<=3) $fcodept4 = $fcodept4.$value["code"];
  //          }
  //      }
  //  }


  //  if($fsizeof<=3){
  //      for($count=$fsizeof;$count<=3;$count++){
  //          $fcodept4 = $fcodept4.'0';
  //      }
  //  }

  //  //last name to codept4
  //  foreach($lnameSplit as $letter){
  //      foreach($alphabets as $alphabet){
  //          if($letter==$alphabet) array_push($lnameClear,$letter);
  //      }
  //  }
  //  $lsizeof = sizeof($lnameClear);
  //  $lcodept4 ='';
  //  for($j=0;$j<sizeof($lnameClear);$j++){

  //      foreach($alphabetCode as $key=>$value){
  //          if($lnameClear[$j]==$value["alphabet"]){
  //              if($j<=3) $lcodept4 = $lcodept4.$value["code"];
  //          }
  //      }
  //  }

  //  if($lsizeof<=3){
  //      for($count=$lsizeof;$count<=3;$count++){
  //          $lcodept4 = $lcodept4.'0';
  //      }
  //  }

  //  $codept4 = $fcodept4.'/'.$lcodept4;
  return codept4;
}

export {
  convertLatLngtoPoint,
  convertCoordinatetoLatLng,
  convertCoordinatetoLatLngLand,
  convertCoordinatetoLatLngLandCenter,
  convertCoordinatetoLatLngBuild,
  convertCoordinatetoLatLngMirror,
  mapRemoveLayer,
  convertCodePt4,
  refreshLayer,
};